import React from "react";
import { useTranslation } from "react-i18next";
import Container from "../../../Components/UI/Container/index";
import Heading from "../../../Components/Heading/index";
import { SectionWrapper } from "../../../assets/css/Custom/AcademicStyle";
import { Icon } from "react-icons-kit";
import { cloudDownload } from "react-icons-kit/fa/cloudDownload";
import { Table } from "react-bootstrap";
// import { Link } from "react-router-dom";
function ScSt({ fontsize }) {
  const {t} = useTranslation();
  return (
    <Container width="1250px">
      <br />
      <Heading
      content={t("cells_top_subtitlee")}
        style={{
          fontSize: "1.5em",
          marginBottom: "20px",
          marginTop: "13px",
          fontWeight: "500",
          background: "#274187",
          color: "#fff",
          padding: "1% 1% 1% 3%",
        }}
      />
       <div>
      
      <Table
        striped
        bordered
        hover
        responsive="md"
        style={{ margin: "50px auto" }}
      >
        <thead>
          <tr>
            <th>S.No.</th>
            <th>Name</th>
            <th>Position </th>
          </tr>
        </thead>
        <tbody>
        <tr>
            <td>1.</td>
            <td>Dr. C.M. Rao</td>
            <td>Chairman</td>
          </tr>
          <tr>
            <td>2.</td>
            <td>Dr. Kuntal Majhi</td>
            <td>Convenor</td>
          </tr>
          <tr>
            <td>3.</td>
            <td>Dr. S.B. Prasad</td>
            <td>Member</td>
          </tr>
          <tr>
            <td>4.</td>
            <td>Dr. Gunda Yoganjanyelu</td>
            <td>Member</td>
          </tr>
          <tr>
            <td>5.</td>
            <td>Sri Gopaljee Ram</td>
            <td>Member</td>
          </tr>
          <tr>
            <td>6.</td>
            <td>Sri Provot Kumar Roy</td>
            <td>Member</td>
          </tr>
          <tr>
            <td>7.</td>
            <td>Sri Ratish Kumar Paswan</td>
            <td>Member</td>
          </tr>
          <tr>
            <td>8.</td>
            <td>Sri Bibhas Sarkar(2022PGCESE11, M.Tech)</td>
            <td>Member</td>
          </tr>
          <tr>
            <td>9.</td>
            <td>Sri Sourav Kumar(2021UGCS038, B.Tech)</td>
            <td>Member</td>
          </tr>
          <tr>
            <td>10.</td>
            <td>Registrar</td>
            <td>Member</td>
          </tr>
        </tbody>
      </Table>
    
  </div>
      <Heading
      content={t("cells_top_subtitle")}
        style={{
          fontSize: "1.5em",
          marginBottom: "20px",
          marginTop: "13px",
          fontWeight: "500",
          background: "#274187",
          color: "#fff",
          padding: "1% 1% 1% 3%",
        }}
      />
      <SectionWrapper>
        <a href="https://nitjsr.ac.in/backend/uploads/uploads_2023/scst_cell/Committee%20is%20constiuted%20for%20SC&ST%20Cell%20to%20resolve%20the%20grivances%20of%20the%20SC&ST%20students%20and%20employees.pdf">
          <p style={{ fontSize: fontsize }} className="pdfLink">
            <Icon icon={cloudDownload} size={18} />
            &nbsp;&nbsp; {t("sc-st_para_li1")}
          </p>
        </a>
        <a href="https://nitjsr.ac.in/backend/uploads/old_uploads/scstcell/Reservation%20&%20Welfare%20Comiteee.pdf">
          <p style={{ fontSize: fontsize }} className="pdfLink">
            <Icon icon={cloudDownload} size={18} />
            &nbsp;&nbsp;{t("sc-st_para_li2")}
          </p>
        </a>
        <a href="https://nitjsr.ac.in/backend/uploads/old_uploads/scstcell/Nomination%20of%20Liaison%20Officer%20for%20enforcement%20of%20orders%20of%20reservation%20in%20posts%20and%20services%20of%20the%20institute.pdf">
          <p style={{ fontSize: fontsize }} className="pdfLink">
            <Icon icon={cloudDownload} size={18} />
            &nbsp;&nbsp; {t("sc-st_para_li3")}
          </p>
        </a>
      </SectionWrapper>
    </Container>
  );
}

export default ScSt;
